export const iconFontAwesomeWritingFileLines = (
	<i className="fa-solid fa-file-lines"></i>
);
